import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import type { ComponentProps } from 'react';

type Props = {
  checked: boolean;
  onToggle: () => void;
} & Omit<ComponentProps<typeof FormControlLabel>, 'control'>;

export const Toggle = ({ checked, onToggle, disabled, ...props }: Props) => {
  return (
    <FormControlLabel
      {...props}
      disabled={disabled}
      control={
        <Switch
          size="medium"
          checked={checked}
          onChange={onToggle}
          color="primary"
          disabled={disabled}
        />
      }
    />
  );
};
